import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

export class AuthenticationFailedError extends EluveError {
  static override readonly errorName = 'AuthenticationFailedError';
  readonly logLevel: LogLevel = 'warn';

  constructor(message = 'Authentication failed', args?: EluveErrorArgs) {
    super(message, args);
  }
}
